import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BasedataService } from "../../shared/basedata.service";
import { Pin } from "./pin.interface";
import { BpConfigService } from "../../config/bp-config.service";

@Injectable()
export class PinApiService extends BasedataService {

  constructor(
    private http: HttpClient,
    configService: BpConfigService
  ) {
    super(configService);
  }

  updatePin(pin: Pin, updatePin: Pin): Observable<Pin> {
    return this.http.patch<Pin>(`${this.getFullUrl('pins')}/${pin.id}`, updatePin);
  }

  getPlanPins(): Observable<Pin[]> {
    const pins = this.http.get<Pin[]>(this.getFullUrl('pins') + '?pointType=plan');
    return pins;
  }

  getBimPins(): Observable<Pin[]> {
    const pins = this.http.get<Pin[]>(this.getFullUrl('pins') + '?pointType=bim');
    return pins;
  }
}
